// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Fire Blast",
  id: "fire-blast",
  metadata: {
    aspect: SavedSpellAspect.Fire,
    imports: ["fire"],
    icon: {
      "backgroundColor": 4267306,
      "layers": [
        {
          "iconKey": "fireball",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -8,
          "color": 16755558
        }
      ]
    },
  },
};

export default metadata;
